import React, { useState } from 'react';
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';
import API from "../../Services/BaseService";
import CommonPopup from '../../Component/CommonPopup/CommonPopup';
import appstore from '../../assets/img/appstore.png';
import googleplay from '../../assets/img/googleplay.png';
import Logo from '../../assets/img/Logo_final.png';
import PhoneInput from 'react-phone-number-input/input';
import PhoneInputs from 'react-phone-input-2';
import PageNotFound from '../FallBackUI/PageNotFound';
import { useEffect } from 'react';
import "../ForgotPassword/forgotpassword.css"

const ForgotEmail = () => {
    const history = useHistory();
    const [popupTitle, setPopupTitle] = useState("");
    const successData = useSelector(state => state.LoginReducer.payload);
    const [popupMsg, setPopupMsg] = useState("");
    const [popupType, setPopupType] = useState("");
    const [popupActionType, setPopupActionType] = useState("");
    const [popupActionValue, setPopupActionValue] = useState("");
    const [popupActionPath, setPopupActionPath] = useState("");
    const [errorMessage, setErrorMessage] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState("");
    const [phoneNoError, setPhoneNoError] = useState('');
    const [countryId, setCountryId] = useState("+1");
    const [extension, setExtension] = useState("");
    const [country, setCountry] = useState("");
    console.log("countryId", countryId);
    const [errors, setErrors] = useState("");
    const [errorFlag, setErrorFlag] = useState(false);

    let value = window.location.href.split("id=");

    function formatMobileNO(value) {
        var x = value.replace(/\D/g, '').match(/(\d{1})(\d{3})(\d{3})(\d{4})/);
        console.log("value of x", x);
        value = '+' + x[1] + '(' + x[2] + ')' + x[3] + '-' + x[4];
        console.log("mobileno", value);
        return value;
    }

    const handleForgotEmail = (event) => {
        event.preventDefault();

        setPhoneNoError("")
        // if (countryId == +1) {
        if (!phoneNumber) {
            setPhoneNoError("Phone Number is required")
            return;
        }
        else if (phoneNumber.length < 10) {
            setPhoneNoError("Phone Number must have 10 digits ")
            return;
        }
        // }
        let request = {
            phone_no: phoneNumber,
            country_id: 1,
            country_code: !countryId ? "+1" : countryId,
            extension: extension,

            // seller_id: successData.seller_id,
            // seller_token: successData.seller_token,
        }
        API.post("forgotEmail/condition", request)
            .then((response) => {
                if (response.data.success == true) {
                    togglePopup()
                    setPopupTitle("Forgot Username");
                    setPopupMsg("An SMS with Username has been sent to your phone");
                    setPopupType("success");
                    setPopupActionType("redirect");
                    setPopupActionValue("ok");
                    setPopupActionPath("/login")

                } else {
                    const { data } = response;
                    togglePopup()
                    setPopupTitle("Change Username");
                    // setPopupMsg("Change Password is not Updated, Please try Again");
                    setPopupMsg(data.error.err);
                    setPopupType("error");
                    setPopupActionType("close");
                    setPopupActionValue("close");
                }
            },
                (error) => {
                    togglePopup()
                    setPopupTitle("Error");
                    setPopupMsg("Something went wrong, Please try Again");
                    setPopupType("error");
                    setPopupActionType("close");
                    setPopupActionValue("close");
                })
            .catch(function (error) {
                if (error.response) {
                    setErrors(error.response.data.error)
                    setErrorFlag(true)
                }
            });

    }
    const togglePopup = () => {
        setIsOpen(!isOpen);
    }

    const handleOnChange = (value) => {
        setPhoneNumber(value);
        console.log("inside handle")
        console.log("phn no", value)
    }
    const handleextension = (e) => {
        const value = e.target.value.replace(/\D/g, "");
        setExtension(value)
    }
    useEffect(() => fetchCountry()
        , [])

    async function fetchCountry() {
        const country = API.get('country');
        country.then((response) => {

            if (response.data.success === true) {
                setCountry(response.data.data);
            }
            else {
                setErrors(response.data.error.name)
                setErrorFlag(true)
            }

        }).catch(function (error) {
            if (error.response) {
                setErrors(error.response.data.error)
                setErrorFlag(true)
            }
        });
    }
    return (
        <div>
            <div>
                {errorFlag === true ? <PageNotFound error={errors} /> :
                    <main id="main" className="inner-page">
                        <div className="col-lg-4  loginBlock forgotpage">
                            <button className="back-btn-paymentform backBtn" onClick={() => history.push("/login")}><i className="icofont-arrow-left"></i> Back</button>
                            <div className="col-lg-12 card">
                                <div className="logo"><img alt="" src={Logo} /></div>
                                <form className="registrationform" onSubmit={handleForgotEmail} >
                                    <h2 className="title">Forgot Username</h2>
                                    <div className="row changePassblock">

                                        <div className="col-lg-4 form-group countrycode">
                                            <div className="tbox">
                                                <select className="form-control custom-select browser-default textbox" id="drop" placeholder=""
                                                    onChange={(e) => setCountryId(e.target.value)} value={countryId}>
                                                    <option style={{ display: "none" }}>{countryId}</option>
                                                    {country.length > 0 &&
                                                        <>
                                                            {country.map((country) => <>
                                                                <option key={country.id} value={`+${country.country_code}`} >
                                                                    {country?.country_name}({`+${country.country_code}`})
                                                                </option>
                                                            </>)}
                                                        </>}
                                                </select>
                                                <label for="drop" className={"input-has-value"}>Country code</label>
                                            </div>
                                        </div>
                                        <div className="col-lg-5">
                                            <div className="tbox">

                                                <PhoneInputs
                                                    className="textbox"
                                                    country={'us'}
                                                    disableDropdown={true}
                                                    disableCountryCode={true}
                                                    onlyCountries={['us']}
                                                    value={phoneNumber}
                                                    onChange={(data) => handleOnChange(data,)}
                                                    placeholder=""
                                                ></PhoneInputs>
                                                <label htmlFor="phone_no" className={"input-has-value required"}>Phone</label>
                                                <p className="form-input-error" >{phoneNoError}</p>
                                            </div>
                                        </div>
                                        <div className="col-lg-3">
                                        <div className='tbox'>
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="extentation1"
                                                value={extension}
                                                onChange={(e) => handleextension(e)}

                                            />
                                            <label for="drop" className={"input-has-value"}>Extension</label>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 loginBtn">
                                            <button className="cta-btn">Submit</button>
                                        </div>
                                    </div>
                                </form>

                            </div> </div>
                        <section id="playstoreBlock" className="playstoreBlock">
                            <div className="container">
                                <div className="row content">
                                    <div className="col-lg-12">
                                        <img src={appstore} />
                                        <img src={googleplay} />
                                    </div>
                                </div>
                            </div>
                        </section>
                        {isOpen &&
                            <CommonPopup
                                handleClose={togglePopup}
                                popupTitle={popupTitle}
                                popupMsg={popupMsg}
                                popupType={popupType}
                                popupActionType={popupActionType}
                                popupActionValue={popupActionValue}
                                popupActionPath={popupActionPath}
                            />}
                    </main>}

            </div>
        </div>
    )
}
export default ForgotEmail;